import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { updateToken } from '../services/SessionService';

axios.interceptors.request.use((config:AxiosRequestConfig) => {
    const headers = retrieveHeadersFromStorage();    
    
    Object.keys(headers).forEach((key:string) => {
        config.headers[key] = headers[key];
    });
    return config;
}, (error) => {
    return Promise.reject(error);
});

axios.interceptors.response.use((response:AxiosResponse) => {
    saveImportantHeadersInStorage(response);
    return response;
}, async (error) => {
    const data = error?.response.data || {}

    try {
        if (error?.response?.status === 401) {
            await updateToken();
            return Promise.resolve();
        }

        return Promise.reject(data);
    } catch (e) {
        return Promise.reject(data);
    }
});

function saveImportantHeadersInStorage(response:AxiosResponse):void {
    const hasAuthorizationHeader = !response.headers['authorization']
    const hasMuvenHeader = !!Object.keys(response.headers).filter((key) => {
        return isKeyMuvenRelated(key)
    }).length

    if (!hasAuthorizationHeader || !hasMuvenHeader) {
        return;
    }

    localStorage.setItem("authorization", response.headers['authorization']);

    Object.keys(response.headers).filter((key) => {
        return isKeyMuvenRelated(key)
    }).forEach((key) => {
        localStorage.setItem(key, response.headers[key]);
    })
}

function retrieveHeadersFromStorage():IHeaderObj {
    const headers:IHeaderObj = {
        authorization: `Bearer ${localStorage.getItem("authorization")}`,
    }

    Object.keys(localStorage).filter((key) => {
        return isKeyMuvenRelated(key)
    }).forEach((key) => {
        headers[key] = localStorage.getItem(key) || ""
    })

    return headers
}

function isKeyMuvenRelated(key:string):boolean {
    return /c2b-/.test(key)
}

interface IHeaderObj {
    [key:string]:string
}
